<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29.402"
    height="19.828"
    viewBox="0 0 29.402 19.828"
  >
    <g transform="translate(-260.799 -427.086)">
      <path
        d="M274.428,439.952c-3.249,0-7.478-.109-8.724-.6a2.046,2.046,0,0,1-1.312-1.126,2.341,2.341,0,0,1,.478-1.9c.07-.121.141-.242.206-.364a6.728,6.728,0,0,0,.317-2.8c-.005-.263-.009-.5-.005-.7.021-.923,0-2.556,0-2.556a.5.5,0,0,1,.432-.5c1.362-.188,5.1-.934,6.039-2.116a.5.5,0,0,1,.392-.189h0a.5.5,0,0,1,.392.189,8.67,8.67,0,0,1,1.853,4.928,7.626,7.626,0,0,0,1.56,1.033h0c.316-.062.688.1,1.657.579a8.268,8.268,0,0,0,1.4.61,17.429,17.429,0,0,0,2.717.729,3.465,3.465,0,0,0,.947-.064,2.663,2.663,0,0,1,1.464.083c.214.072,2.1.74,2.177,1.885.027.372-.129.909-1.022,1.359a20.964,20.964,0,0,1-7.086,1.479C277.852,439.915,276.3,439.952,274.428,439.952Zm-8.036-9.637c.005.556.01,1.523,0,2.158,0,.188,0,.415.005.663a7.314,7.314,0,0,1-.435,3.291c-.07.132-.146.263-.223.395-.237.409-.482.831-.4,1.074.06.174.321.36.735.524,1.575.624,9.806.579,12.2.476a19.96,19.96,0,0,0,6.715-1.39c.312-.16.437-.319.433-.377-.017-.233-.69-.735-1.5-1.009a1.684,1.684,0,0,0-.98-.044,4.423,4.423,0,0,1-1.24.069,17.531,17.531,0,0,1-2.851-.758,7.985,7.985,0,0,1-1.584-.677,7.591,7.591,0,0,0-1.093-.488c-.481.1-.86-.17-2.469-1.358a.5.5,0,0,1-.2-.392,7.665,7.665,0,0,0-1.318-4.129C270.7,429.521,267.592,430.12,266.392,430.315Z"
        fill="#777"
      />
      <path
        d="M275.228,438.29c-.829,0-1.647-.027-2.46-.08-.385-.013-1.27-.115-2.272-.251-.978-.132-2.086-.281-2.6-.281a7.509,7.509,0,0,1-2.514-.6.5.5,0,0,1,.4-.918,6.474,6.474,0,0,0,2.15.523h.005c.547,0,1.637.147,2.69.29.883.119,1.8.242,2.168.242h0a38.311,38.311,0,0,0,4.945,0,19.61,19.61,0,0,1,3.787-.533,25.693,25.693,0,0,0,3.689-.552.5.5,0,0,1,.218.977,26.824,26.824,0,0,1-3.848.573,19.476,19.476,0,0,0-3.7.52Q276.538,438.292,275.228,438.29Z"
        fill="#777"
      />
      <g>
        <rect
          width="5.624"
          height="1"
          transform="translate(260.799 444.874) rotate(-63.435)"
          fill="#777"
        />
        <path
          d="M264.271,442.786l-.722-2.136-2.346.506-.211-.979,3.218-.693,1.008,2.981Z"
          fill="#777"
        />
      </g>
      <g>
        <rect
          width="1"
          height="5.624"
          transform="translate(286.791 439.086) rotate(-26.574)"
          fill="#777"
        />
        <path
          d="M286.728,441.581l-.947-.32,1.008-2.981,3.218.693-.211.979-2.346-.506Z"
          fill="#777"
        />
      </g>
      <g>
        <rect
          width="5.625"
          height="1"
          transform="translate(268.417 446.773) rotate(-83.382)"
          fill="#777"
        />
        <path
          d="M270.968,443.624l-1.409-1.761-2.032,1.277-.532-.846,2.787-1.754L271.749,443Z"
          fill="#777"
        />
      </g>
      <g>
        <rect
          width="1"
          height="5.625"
          transform="matrix(0.993, -0.114, 0.114, 0.993, 281.783, 441.211)"
          fill="#777"
        />
        <path
          d="M280.87,443.534l-.78-.625,1.969-2.459,2.786,1.753-.532.846-2.031-1.276Z"
          fill="#777"
        />
      </g>
      <g>
        <rect
          width="1"
          height="5.624"
          transform="matrix(1, -0.024, 0.024, 1, 275.399, 441.292)"
          fill="#777"
        />
        <path
          d="M277.624,443.441l-1.639-1.548-1.834,1.547-.645-.764,2.516-2.123,2.289,2.161Z"
          fill="#777"
        />
      </g>
    </g>
  </svg>
</template>
